import NovoUsuario1 from './NovoUsuario1';

export default NovoUsuario1;